import {ConsentSubject} from '@dms/api/shared';

import {ConsentTypeFormType} from '../components/GdprConsentTypeForm/components/ConsentTypeFormTemplate';

type ConsentTypeRecipientValues = Pick<
  ConsentTypeFormType,
  'subject' | 'branchId' | 'recipientCustomerId'
>;

/**
 * Keeps only the recipients that belong to the subject. A branch belongs to a branch consent type
 * only, so a stale branch from a previously selected subject is cleared. A third party is required
 * for a third-party consent type and optional for a tenant or branch one, so it is always kept.
 */
export const getConsentTypeRecipientFields = (values: ConsentTypeRecipientValues) => ({
  branchId: values.subject === ConsentSubject.BRANCH ? values.branchId : null,
  recipientCustomerId: values.recipientCustomerId,
});
